<template>
  <div class="horizontal-card grid md:grid-cols-2 grid-cols-1 overflow-hidden rounded-xl">
    <div v-if="content.img">
      <img class="object-cover w-full h-full" :src="content.img.filename" :alt="content.title" />
    </div>
    <div class="bg-white md:px-12 md:py-10 px-8 py-6">
      <h3 class="text-primary font-medium md:text-3xl text-2xl pb-3" v-html="content.title"></h3>
      <vue-markdown class="custom-markdown">{{content.text}}</vue-markdown>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    content: {
      type: Object,
      default: null,
    },
  },
};
</script>

<style lang="scss">
.horizontal-card {
  box-shadow: 0 5px 10px rgba(154, 160, 185, 0.05),
    0 15px 40px rgba(166, 173, 201, 0.2);
}
.custom-markdown {
  p,
  li,
  h1,
  h2,
  h3,
  h4,
  h5 {
    @apply font-medium leading-normal;
  }
  p,li {
      @apply text-gray-500 text-base
  }
  p {
    @apply py-2
  }
  h4 { 
    @apply text-primary text-xl py-3;
  }
  ul {
    padding-left: 20px;
    list-style: disc;
  }
}
</style>